import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import reducers from './reducers';
import * as REPORTERS from './reporters';
import Routes from './routes';
import './css/index.css';
import './constants/config/authentication';

const enhancers = compose( 
    applyMiddleware( ...[ ReduxThunk, REPORTERS.DTM ]), 
    window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f
),
store = createStore( reducers, enhancers ),
app = document.getElementById( 'root' );

if( app ){
    ReactDOM.render(
        <Provider store={ store }>
            <Routes />
        </Provider>,
        app
    );
}